import { jsx as _jsx } from "react/jsx-runtime";
import "reflect-metadata";
import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-tooltip/dist/react-tooltip.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "./presentation/components/css/lightpick.css";
import AppSearchResults from "./AppSearchResults";
import { initSentry } from "./infrastructure/sentry/sentryConfig";
initSentry("search-results");
const containerId = 'search-results';
let observer = null;
const renderApp = () => {
    const container = document.getElementById(containerId);
    if (!container)
        return false;
    if (container.dataset.reactMounted === "true")
        return true;
    const root = ReactDOM.createRoot(container);
    root.render(_jsx(React.StrictMode, { children: _jsx(AppSearchResults, {}) }));
    container.dataset.reactMounted = "true";
    if (observer)
        observer.disconnect();
    document.removeEventListener('DOMContentLoaded', renderApp);
    return true;
};
// BFCache (back/forward cache) restores the page with the old DOM but re-executes
// the script. The module-level flag was stale in that scenario, causing the app to
// never re-mount. Clearing the dataset attribute on pageshow(persisted) lets
// renderApp re-create the React root when the user navigates back.
window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
        const container = document.getElementById(containerId);
        if (container) {
            delete container.dataset.reactMounted;
        }
    }
});
if (!renderApp()) {
    observer = new MutationObserver(() => {
        renderApp();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('DOMContentLoaded', renderApp);
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
